<!-- My Account Bonuses -->
<div class="bonus_left--slider myacc-cont">
  <div class="bonus_left--container">
    <div class="icon-cancel" (click)="goBack()"></div>

    <div class="bonus_left--content">
      <div class="bonus_left--content_heading mb15 myacc-pages-hdng">
        <h2 class="heading">
          <p>{{ "bonusComp.bonus1" | translate }}</p>
          <span class="back-icn" (click)="goBack()">
            <small class="show-desk">✕</small
            ><i class="icon icon-arrow-2 show-mobile"></i
          ></span>
        </h2>
      </div>
      <!-- Bonus Card -->
      <div class="container-fluid">
        <section class="bonus-tabs">
          <ng-container
            *ngIf="
              showFreeSpinGames ||
              (eligibleBonusList && eligibleBonusList.length)
            "
          >
            <h4 class="sub_heading">
              {{ "bonusComp.rewardsavailable" | translate }}
            </h4>
            <ng-container *ngIf="!paginationItems">
              <div class="swiper-card-empty bonus__card">
                <div class="bonus__swiper--content--body">
                  <div class="bonus__swiper--img animated-background"></div>
                  <div class="bonus__swiper--txt">
                    <h2 class="animated-background">
                      <span class="animated-background"></span>
                      <span class="animated-background"></span>
                    </h2>
                    <h4 class="animated-background"></h4>
                  </div>
                </div>
                <div class="bonus__swiper--content--footer">
                  <h4 class="animated-background"></h4>
                </div>
              </div>
              <div class="bonus-swiper-pagination">
                <div class="swiper-pagination-bullet"></div>
              </div>
            </ng-container>
            <div class="bonus__swiper" id="bonus__swiper" *ngIf="paginationItems.length >= 0">
              <div class="bonus-cards-swiper swiper swiper-container clearfix">
                <div class="swiper-wrapper">
                  <ng-container
                    *ngIf="eligibleBonusList && eligibleBonusList.length"
                  >
                    <div
                      class="swiper_card swiper-slide"
                      *ngFor="let bonus of eligibleBonusList; let i = index"
                    >
                      <div class="bonus__swiper--overlay"></div>
                      <div class="bonus-swiper__bg">
                        <div
                          class="bonus__swiper--content"
                          [ngStyle]="{
                            background:
                              'url(' +
                              siteUrlPath +
                              '/' +
                              mediaUrlPath +
                              '/bonus/bonusBg.png)no-repeat 0 0/cover'
                          }"
                        >
                          <div
                            class="bonus__swiper--content--body deposit_bonus_card"
                          >
                            <div class="bonus__swiper--img">
                              <img
                                src="{{ siteUrlPath }}/{{
                                  mediaUrlPath
                                }}/bonus/bonus-coin-icon.png"
                                alt="Bonus Coin Icon "
                              />
                            </div>
                            <div class="bonus__swiper--txt">
                              <h2>
                                <span class="bonus-top-title">{{getTranslateTextAndObject(bonus).jsonKey | translate : getTranslateTextAndObject(bonus)
                                          .eligibleBonusPropertyValues
                                }}</span>
                                <p class="bonus-top-subtitle">{{
                                  getTranslateTextAndObject(bonus).jsonKey2
                                    | translate
                                      : getTranslateTextAndObject(bonus)
                                          .eligibleBonusPropertyValues
                                }}</p>
                              </h2>
                              <!-- <h4 *ngIf="bonus.campaignEndDate">
                                {{ "bonusComp.expireddate" | translate }}
                                {{
                                  getDate(bonus.campaignEndDate)
                                    | date : "dd.MM.yyyy"
                                }}
                              </h4> -->
                            </div>
                          </div>
                          <div
                            class="bonus__swiper--content--footer"
                            (click)="openDeposit(bonus)"
                          >
                            <h4>
                              {{ "bonusComp.claimFreeSpins" | translate }}
                            </h4>
                            <h4 *ngIf="bonus.campaignEndDate" class="expire--date">
                              {{ "bonusComp.expireddate" | translate }}
                              {{
                                getDate(bonus.campaignEndDate)
                                  | date : "dd.MM.yyyy"
                              }}
                            </h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <div
                    class="swiper_card swiper-slide"
                    *ngFor="let game of filteredFreeSpinGames; let i = index"
                  >
                    <div class="bonus__swiper--overlay"></div>
                    <div class="bonus-swiper__bg">
                      <div
                        class="bonus__swiper--content"
                        [ngStyle]="{
                          background:
                            'url(' +
                            siteUrlPath +
                            '/' +
                            mediaUrlPath +
                            '/bonus/bonusBg.png)no-repeat 0 0/cover'
                        }"
                      >
                        <div
                          class="bonus__swiper--content--body free_spins_card"
                        >
                          <div class="bonus__swiper--img">
                            <img
                              src="{{ siteUrlPath }}/{{
                                mediaUrlPath
                              }}/bonus/bonus-coin-icon.png"
                              alt="Bonus Coin Icon"
                            />
                          </div>
                          <div class="bonus__swiper--txt">
                            <h2>
                              <span class="bonus-top-title">{{ "bonusComp.freeSpins" | translate }} </span
                              ><p class="bonus-top-subtitle">{{ game.name }}</p>
                            </h2>
                            <!-- <h4>
                              {{ "bonusComp.expireddate" | translate }}
                              {{ getDate(game.expDate) | date : "dd.MM.yyyy" }}
                            </h4> -->
                          </div>
                        </div>
                        <div
                          class="bonus__swiper--content--footer"
                          (click)="
                            gameLauncher(game.gameCode, game.multilingualUrl)
                          "
                        >
                          <h4>{{ "bonusComp.claimFreeSpins" | translate }}</h4>
                           <h4 class="expire--date">
                              {{ "bonusComp.expireddate" | translate }}
                              {{ getDate(game.expDate) | date : "dd.MM.yyyy" }}
                            </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>

              <div class="bonus-swiper-pagination">
                <div
                  class="swiper-pagination-bullet"
                  [ngClass]="isActiveIndex == ind ? 'active' : ''"
                  *ngFor="let item of paginationItems; let ind = index"
                  (click)="changeSwiper(ind)"
                ></div>
              </div>
            </div>
          </ng-container>
          <div class="clearfix"></div>
          <!--for loop-->
          <ng-container *ngIf="bonusDetails">
            <h4 class="sub_heading mt25 mb25">
              {{ "bonusComp.activerewards" | translate }}
            </h4>
            <div
              class="col-xs-12 col-md-12 bonus__card"
              *ngFor="let bonusDetail of bonusDetails; let i = index"
              [class.bonus__active]="i == current"
            >
              <div class="bonus__card-header" (click)="current = i">
                <div class="bonus__row bonus--name">
                  {{ bonusDetail.bonusName }}
                </div>
                <div class="bonus__card_hide">
                  <div class="bonus__row bonus__expiry">
                    <span class="col">
                      <span class="bonus__expiry--date-text">{{
                        "bonusComp.expireddate" | translate
                      }}</span>
                      <span class="bonus__expiry--date expiry-alert">{{
                        bonusDetail.expiredDate | date : "dd.MM.yyyy h:mma"
                      }}</span>
                    </span>
                  </div>
                  <div
                    class="bonus__row bonus--amount bonus--amount_percentage"
                  >
                    {{ bonusDetail.distanceToRelease | currencyPipe }}
                    <div class="progress">
                      <span class="progress--percentage"
                        >{{ bonusDetail.wageredPercent | currencyPipe }}%</span
                      >
                      <span class="progress__bar">
                        <span
                          class="progress--fill"
                          [style.width.%]="
                            bonusDetail.wageredPercent | number : '1.2-2'
                          "
                        ></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="bonus__card-body"
                [class.bonus__card-body--hide]="current != i"
              >
                <div class="bonus__row">
                  <div class="bonus--descripion">
                    {{ "bonusComp.bonus3" | translate }}
                  </div>

                  <div class="bonus--amount">
                    {{
                      bonusDetail.offeredCRP +
                        bonusDetail.offeredDRP +
                        bonusDetail.offeredRRP | currencyPipe
                    }}
                  </div>
                </div>

                <div class="bonus__row">
                  <div class="bonus--descripion">
                    {{ "bonusComp.bonus4" | translate }}
                  </div>

                  <div class="bonus--amount">
                    {{
                      bonusDetail.currentCRP +
                        bonusDetail.currentDRP +
                        bonusDetail.currentRRP +
                        bonusDetail.currentWRP | currencyPipe
                    }}
                  </div>
                </div>

                <div class="bonus__row">
                  <div class="bonus--descripion">
                    {{ "bonusComp.bonus5" | translate }}
                  </div>

                  <div class="bonus--amount">
                    {{ bonusDetail.totalWagerAmount | currencyPipe }}
                  </div>
                </div>

                <div class="bonus__row top-align">
                  <div class="bonus--descripion">
                    {{ "bonusComp.remainingwageringrequirement" | translate }}
                  </div>

                  <div class="bonus--amount bonus--amount_percentage">
                    {{ bonusDetail.distanceToRelease | currencyPipe }}
                    <div class="progress">
                      <span class="progress--percentage"
                        >{{ bonusDetail.wageredPercent | currencyPipe }}%</span
                      >
                      <span class="progress__bar">
                        <span
                          class="progress--fill"
                          [style.width.%]="
                            bonusDetail.wageredPercent | number : '1.2-2'
                          "
                        ></span>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="bonus__row bonus__expiry">
                  <span class="col">
                    <span class="bonus__expiry--date-text">
                      {{ "bonusComp.crediteddate" | translate }}</span
                    >
                    <span class="bonus__expiry--date">{{
                      bonusDetail.offeredDate | date : "dd.MM.yyyy h:mm a"
                    }}</span>
                  </span>
                  <span class="col">
                    <span class="bonus__expiry--date-text">{{
                      "bonusComp.expireddate" | translate
                    }}</span>
                    <span class="bonus__expiry--date expiry-alert">{{
                      bonusDetail.expiredDate | date : "dd.MM.yyyy h:mm a"
                    }}</span>
                  </span>
                </div>
                <button
                  class="bonus__row bonus__cancel-btn"
                  (click)="
                    openModal(
                      'dropbonusConfirmation',
                      bonusDetail.ecrBonusId,
                      bonusDetail.bonusName
                    )
                  "
                >
                  {{ "bonusComp.cancelbonus" | translate }}
                </button>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="!bonusDetails">
            <div
              class="col-xs-12 col-md-12 bonus__card"
              *ngFor="let bonusDtls of [1,2,3]; let i = index"
            >
              <div class="bonus__card-body">
                <div class="bonus--name col-xs-12 animated-background"></div>

                <div
                  class="bonus__row col-xs-12"
                  *ngFor="let bonus of [1, 2, 3, 4, 5]; let i = index"
                >
                  <div class="bonus--descripion animated-background"></div>

                  <div class="bonus--amount animated-background"></div>
                </div>

                <div
                  class="bonus__row bonus__expiry col-xs-12 animated-background"
                ></div>
              </div>
            </div>
          </ng-container>

          <ng-container
            *ngIf="(!bonusDetails || bonusDetails.length === 0) && bonusLoaded"
          >
            <div class="bonus-columns no-bonus">
              <h5>
                <span class="fi custom-error_warning"></span>
                {{ "bonusComp.bonus9" | translate }}
              </h5>
              <p>{{ "bonusComp.bonus10" | translate }}</p>
            </div>
          </ng-container>
        </section>
      </div>
    </div>
  </div>
</div>

<modal
  id="dropbonusConfirmation"
  class="modal_smooth_open dropbonusConfirmation"
>
  <div class="fixed-scroll">
    <div class="site_modal middleAlignBlock">
      <div class="middleAlign">
        <div class="site_modal--body site_modal--body-small">
          <div
            class="hidden-md hidden-lg mobile_modal_closeicon"
            (click)="closeModal('dropbonusConfirmation')"
          >
            <i class="icon-close-simplified"></i>
          </div>
          <div
            class="hidden-xs hidden-sm icon-cancel-svg"
            (click)="closeModal('dropbonusConfirmation')"
          ></div>

          <h4 class="headingtitle titlepadding">
            {{ "bonusComp.areyousure" | translate }} {{ cancelBonusName }}
          </h4>
          <p>{{ "bonusComp.actionnonreversable" | translate }}</p>

          <div class="clearfix mt-20">
            <a href="JavaScript:Void(0);" (click)="cancelBonus()">{{
              "bonusComp.cancelit" | translate
            }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</modal>
